import {h} from 'preact';

export default () => (
    <div className="loadingIndicator">
        <span>Suche Schulen ...</span>
    </div>
);
